import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, isDevMode } from '@angular/core';
import { ThemePreferenceService } from '@design-system/theme/theme-preference.service';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { LoggingConfigInjectionToken } from '../framework/logging-and-error-handling/logging-config';
import { CandCHttpInterceptor } from '../framework/authentication/interceptors/http.interceptor';
import { AuthInitializerService } from '../framework/authentication/auth-initializer.service';
import { provideServiceWorker } from '@angular/service-worker';

function initAuth(authInitializer: AuthInitializerService) {
  return () => authInitializer.initializeAuth();
}

function initThemeFromStorage() {
  return () => ThemePreferenceService.applyStoredThemeFromLocalStorage();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      // After the shell loads, prefetch lazy submodule chunks so first navigation into an area is faster.
      withPreloading(PreloadAllModules)
    ),
    provideHttpClient(
      withInterceptors([CandCHttpInterceptor])
    ),
    provideAnimationsAsync(),
    {
      provide: LoggingConfigInjectionToken,
      useValue: {
        threshold: NgxLoggerLevel.DEBUG,
        logToExternalService: false,
        stackTrace: true
      }
    },
    importProvidersFrom(
      LoggerModule.forRoot({
        level: NgxLoggerLevel.DEBUG,
        serverLogLevel: NgxLoggerLevel.OFF
      })
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: initThemeFromStorage,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initAuth,
      deps: [AuthInitializerService],
      multi: true
    },
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    })
  ]
};

